import { render } from "./EmailTemplateRenderer.vue?vue&type=template&id=fd535b5a&scoped=true&ts=true"
import script from "./EmailTemplateRenderer.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateRenderer.vue?vue&type=script&lang=ts"

import "./EmailTemplateRenderer.vue?vue&type=style&index=0&id=fd535b5a&scoped=true&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd535b5a"]])

export default __exports__